import { solidstate } from ":setup/qstate";
import type { GradingData, AParticipant } from "../_model";
import { Show } from "solid-js";
import { URLViewer, type Props as URLViewerProps } from "./url-viewer";
import { Select } from ":ui/select";
import { Tooltip } from ":ui/tooltip";
export type Props = {
  data: GradingData;
  participant: AParticipant;
  onGraded?: (props: { tracker: Record<string, number>; gradedAll: boolean }) => void;
};
export function Scoring(props: Props) {
  const c_keys = props.data?.c_keys;
  const criteria = props.data?.criteria;
  const $url = solidstate.create(undefined as URLViewerProps["url"]);
  const $tracker = solidstate.create({} as { [k: string]: any });

  function onGrade(fprops: { key: string; value: any }) {
    const tracker = $tracker.value;
    tracker[fprops.key] = fprops.value;
    const graded_all = Object.keys(tracker).length >= c_keys.length;
    $tracker.set(tracker);
    props.onGraded({ tracker: tracker, gradedAll: graded_all });
  }

  return (
    <Show when={$url.value == undefined} fallback={<URLViewer url={$url.value} onExit={() => $url.set(undefined)} />}>
      <main class="flex flex-col w-full h-full gap-1.5 content-between overflow-hidden">
        <section class="grid grid-cols-3 w-full h-fit text-0.6em gap-2 !hidden <sm:(!grid-cols-2 gap-1 )">
          <Info title={`First Name`} value={props.participant?.first_name ?? "not specified"} />
          <Info title={`Last Name`} value={props.participant?.last_name ?? "not specified"} />
          <Info title={`Track`} value={props.participant?.tracks ?? "not specified"} />
        </section>
        <section class="flex flex-col w-full h-full gap-2 px-1 py-2 rounded-md !overflow-y-auto overflow-x-hidden">
          <Show
            when={c_keys != undefined && c_keys.length > 0}
            fallback={"Unfortunately, There are no evaluation criteria, contact platform support to resolve this!"}
          >
            {c_keys.map((q, i) => {
              const c = criteria[q];
              const question = c?.name;
              const answer = props.participant?.scores[q]?.answer;
              const grade = props.participant?.scores[q]?.score;
              const options = c?.scale?.map((item) => item.grade);
              return (
                <section class="grid grid-cols-[1fr_10%] w-full h-fit px-2 py-2 gap-2 bg-bg-alt rounded-xl text-0.7em <sm:(!flex !flex-col gap-2)">
                  <div class="flex flex-col w-full h-full overflow-hidden gap-2">
                    <p class="flex flex-row w-full h-fit capitalize font-bold text-1em text-brand">
                      {String(question)}
                    </p>
                    {!answer.trim().startsWith("http") ? (
                      <span>{answer ?? "unanswered"}</span>
                    ) : (
                      <button
                        class="form-btn  !w-fit !h-35px !text-0.8em !whitespace-nowrap !font-bold <sm:(!h-40px !items-center !justify-center !self-center !w-full)"
                        // disabled={props.value == undefined}
                        onClick={(e) => window.open(answer, "_blank")}
                      >
                        {answer == undefined ? "Not Provided" : "View"}
                      </button>
                    )}
                  </div>
                  <div class="relative flex flex-col w-full h-fit gap-1 items-center justify-center !self-center ">
                    <Tooltip.default
                      class="flex flex-col w-400px h-fit"
                      _elements={{
                        main: <div class="i-ix:question-filled w-24px h-24px text-brand" />,
                      }}
                      _class={{
                        main: "self-end",
                        children: "sm:right-10%",
                      }}
                    >
                      <p class="grid grid-cols-[1fr_10%] w-full h-full bg-bg text-0.8em gap-2 rounded-xl px-2 py-1 border-solid border-2 border-border-card">
                        {c?.scale?.map((item) => {
                          return (
                            <>
                              <span class="text-text-alt !whitespace-nowrap">{item.hint}</span>
                              <span class="text-brand content-end items-center justify-end">{item.grade}</span>
                            </>
                          );
                        })}
                      </p>
                    </Tooltip.default>
                    <Select
                      class="form-select w-full"
                      options={options}
                      placeholder="Grade"
                      initialValue={grade}
                      onselected={(selections) => {
                        const value = selections[0];
                        onGrade({ key: q, value });
                      }}
                    />
                  </div>
                </section>
              );
            })}
          </Show>
        </section>
      </main>
    </Show>
  );
}

function showURL(e: Event, _url: URLViewerProps["url"], onSetURL: (url: URLViewerProps["url"]) => void) {
  e.preventDefault();
  if (_url.type === "link") {
    let link = _url.url; //"https://www.youtube.com/watch?v=yvNFZhEruUg";
    if (link.includes("youtube")) {
      if (link.includes("/shorts")) {
        window.open(link, "_newtab");
        return;
      } else if (!link.includes("embed")) {
        link = link.replace("watch?v=", "embed/");
        const idx = link.indexOf("&");
        if (idx >= 0) {
          link = link.slice(0, idx);
        }
      }
    }
    // console.log("url link :: ", link);
    _url.url = link;
  }
  onSetURL?.(_url);
  // $url.set(_url);
  // form_transit.set(false);
}

function Info(props: { title: string; value: string }) {
  return (
    <p class="grid grid-cols-[35%_1fr] w-full h-40px items-center justify-center text-center gap-1 <sm:(grid-cols-1 !grid-rows-[35px_40px] !items-start)">
      <span class="h-fit text-text-alt font-bold truncate text-1.2em sm:text-start">{props.title}</span>
      <span class="w-full h-fit capitalize line-clamp-2 sm:(text-start)">{props.value}</span>
    </p>
  );
}

type URLTypes = URLViewerProps["url"]["type"];
function InfoURL(props: {
  title: string;
  value: string;
  type: URLTypes;
  onSetURL: (url: URLViewerProps["url"]) => void;
}) {
  return (
    <p class="grid grid-cols-[35%_1fr] w-full h-40px items-center justify-center text-center content-start gap-1 <sm:(!grid-cols-1 !grid-rows-[35px_40px] !items-start)">
      <span class="h-fit text-text-alt font-bold truncate text-1.2em sm:text-start">{props.title}</span>
      <span class="flex w-full h-full">
        <button
          class="form-btn  !w-fit !h-35px !text-0.9em !whitespace-nowrap !font-bold <sm:(!h-40px !items-center !justify-center !self-center !w-full)"
          disabled={props.value == undefined}
          onClick={(e) => {
            showURL(
              e,
              {
                url: props.value,
                type: props.type,
              },
              props.onSetURL
            );
          }}
        >
          {props.value == undefined ? "Not Provided" : "View"}
        </button>
      </span>
    </p>
  );
}
